/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgForEach = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 15v6h-9v-6zM11.016 3l.273.003c.118.003.225.008.327.014 1.724.1 3.406.786 4.86 1.918l.27.217 3.253 2.712L20 3.999h2v7h-7V9h3.237l-2.772-2.31c-1.199-1-2.583-1.595-3.967-1.675l-.265-.012c-3.196-.083-6.095 1.96-6.94 4.93-1.3 4.577 1.947 8.918 6.472 9.064L11 19v2C5.033 21 .683 15.325 2.37 9.386 3.443 5.606 7.028 3.013 11.016 3zM20 16.999h-5v2h5z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgForEach as ForEach };
